import { GsResponse, RawResponse, toGsResponse } from '../goodstack'

import { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'

type IntegrateWithCalendarProps = {
  provider: string
  code: string
}

export const integrateWithCalendar: MutationFn<IntegrateWithCalendarProps, GsResponse<{}>> = async (
  client,
  { provider, code }
) => {
  const res = await client.post<RawResponse<{ success: true }>>(
    'v1/giving-calendars/auth/exchange-code',
    {
      provider,
      code
    },
    {
      validateStatus: statusCode => [200, 204, 403].includes(statusCode),
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )

  return toGsResponse(res.status, res.data)
}
